import React, { useRef, useState } from 'react';
//https://www.codegrepper.com/code-examples/javascript/document.execCommand%28%27paste%27%29+react
// refcode
export default function CopyExample(inputData) {
  const [copySuccess, setCopySuccess] = useState('');
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    console.log(e, 'e');
    textAreaRef.current.select();
    document.execCommand('copy');
    e.target.focus();
    setCopySuccess('Copied!');
  }

  return (
    <div>
      <form>
        <textarea
          class="shareurltextarea"
          ref={textAreaRef}
          value={inputData.inputData ? inputData.inputData : 'fasd'}
        />
        <a
          onClick={copyToClipboard}
          id="copyshareurl"
          className="dc-share-button"
        >
          {copySuccess ? 'Copied to clipboard' : 'Click to Copy'}
        </a>
      </form>
    </div>
  );
}
